import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  /*
    alarms: {
      [ship1]: [{alarmData}, {alarmData}, ...],
      [ship2]: [{alarmData}, {alarmData}, ...],
      ...
    }
  */
  alarms: {},

  /*
    operationAlarms: {
      [ship1]: {
        [device1]: [string1, ...],
        [device2]: [string1, ...],
        ...
      },
      ...
    }
  */
  operationAlarms: {},

  /*
    requestedSerials: {
      [ship1]: [keyId1, keyId2, ...],
      [ship2]: [keyId1, keyId2, ...],
      ...
    }
  */
  requestedSerials: {},
  alarmFlag: true,
};

const alarmSlice = createSlice({
  name: "alarm",
  initialState,
  reducers: {
    setAlarms: (state, action) => {
      const mode = action.meta?.mode || "snapshot";
      if (mode === "merge") {
        state.alarms = {
          ...state.alarms,
          ...action.payload,
        };
      } else {
        state.alarms = action.payload;
      }
    },
    clearAlarms: (state) => {
      state.alarms = {};
    },
    setOperationAlarms: (state, action) => {
      state.operationAlarms = action.payload;
    },
    setAlarmFlag: (state, action) => {
      state.alarmFlag = action.payload;
    },
    setRequestedSerials: (state, action) => {
      const serials = action.payload;
      state.requestedSerials = serials;
    },
    addRequestedSerial: (state, action) => {
      const { ship, keyId } = action.payload;
      if (!ship || !keyId) return;

      /* INITIALISE OBJECT */
      if (
        typeof state.requestedSerials !== "object" ||
        Array.isArray(state.requestedSerials)
      ) {
        state.requestedSerials = {};
      }

      for (const [existingShip, keyIds] of Object.entries(
        state.requestedSerials
      )) {
        if (keyIds.includes(keyId)) {
          state.requestedSerials[existingShip] = keyIds.filter(
            (id) => id !== keyId
          );
          if (state.requestedSerials[existingShip].length === 0) {
            delete state.requestedSerials[existingShip];
          }
        }
      }
      if (!state.requestedSerials[ship]) {
        state.requestedSerials[ship] = [];
      }

      if (!state.requestedSerials[ship].includes(keyId)) {
        state.requestedSerials[ship].push(keyId);
      }
    },
    removeRequestedSerial: (state, action) => {
      const { ship, keyId } = action.payload;
      if (
        state.requestedSerials?.[ship] &&
        Array.isArray(state.requestedSerials[ship])
      ) {
        state.requestedSerials[ship] = state.requestedSerials[ship].filter(
          (id) => id !== keyId
        );
        if (state.requestedSerials[ship].length === 0) {
          delete state.requestedSerials[ship];
        }
      }
    },
  },
});

export const {
  setAlarms,
  setOperationAlarms,
  clearAlarms,
  setAlarmFlag,
  setRequestedSerials,
  addRequestedSerial,
  removeRequestedSerial,
} = alarmSlice.actions;
export default alarmSlice.reducer;
